let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("11okF")).then(() => parcelRequire('fRfA1'));